// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_btn__filterDate__NUHf\\+ {
  all: unset;
  cursor: pointer;
  color: #fff;
  background-color: #18316e;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  transition: all 0.5s ease-in-out;
  gap: 5px;
  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.21);
}

.styles_btn__filterDate__NUHf\\+ p {
  font-size: 0.8rem;
}

.styles_btn__filterDate__NUHf\\+:hover {
  background-color: #1976d2;
  transform: scale(1.05);
}

.styles_actions__bar__E4iMS,
.styles_filterData__bar__l6-Bz,
.styles_extrator__bar__NcuXn {
  display: flex;
  align-items: center;
  gap: 10px;
}

.styles_actions__bar__E4iMS {
  width: 100%;
  justify-content: space-between;
}

.styles_filterData__bar__l6-Bz {
  align-items: center;
  border-radius: 8px;
  padding: 7px;
  background-color: #fff;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Faturamento/styles.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,eAAe;EACf,WAAW;EACX,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gCAAgC;EAChC,QAAQ;EACR,2CAA2C;AAC7C;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;AACxB","sourcesContent":[".btn__filterDate {\n  all: unset;\n  cursor: pointer;\n  color: #fff;\n  background-color: #18316e;\n  padding: 5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  transition: all 0.5s ease-in-out;\n  gap: 5px;\n  box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.21);\n}\n\n.btn__filterDate p {\n  font-size: 0.8rem;\n}\n\n.btn__filterDate:hover {\n  background-color: #1976d2;\n  transform: scale(1.05);\n}\n\n.actions__bar,\n.filterData__bar,\n.extrator__bar {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.actions__bar {\n  width: 100%;\n  justify-content: space-between;\n}\n\n.filterData__bar {\n  align-items: center;\n  border-radius: 8px;\n  padding: 7px;\n  background-color: #fff;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn__filterDate": `styles_btn__filterDate__NUHf+`,
	"actions__bar": `styles_actions__bar__E4iMS`,
	"filterData__bar": `styles_filterData__bar__l6-Bz`,
	"extrator__bar": `styles_extrator__bar__NcuXn`
};
export default ___CSS_LOADER_EXPORT___;
